import _ from 'lodash';
import { AlertPreferenceAPI } from 'common/notifications/api/AlertPreferenceAPI';

export const UPDATE_PREFERENCE_SETTINGS = 'UPDATE_PREFERENCE_SETTINGS';

export const updatePreferenceSettings = (options) => ({
  type: UPDATE_PREFERENCE_SETTINGS,
  ...options
});

export const LOAD_USER_ACTIVITY_SETTINGS = 'LOAD_USER_ACTIVITY_SETTINGS';
export const LOAD_USER_ACTIVITY_SETTINGS_SUCCESS = 'LOAD_USER_ACTIVITY_SETTINGS_SUCCESS';
export const LOAD_USER_ACTIVITY_SETTINGS_FAILURE = 'LOAD_USER_ACTIVITY_SETTINGS_FAILURE';

export const loadUserActivitySettings = () => {
  return { type: LOAD_USER_ACTIVITY_SETTINGS };
}

export const loadUserActivitySettingsSuccess = (payload) => ({ type: LOAD_USER_ACTIVITY_SETTINGS_SUCCESS, payload });
export const loadUserActivitySettingsFailure = (error) => ({ type: LOAD_USER_ACTIVITY_SETTINGS_FAILURE, error });

export const loadPreferenceSettings = () => {
  return (dispatch) => {
    return AlertPreferenceAPI.get().then((response) => {
      const preferences = _.get(response, 'subscription_preferences', []);
      const settings = _.get(response, 'settings', []);
      dispatch(updatePreferenceSettings({
        preferenceSettings: {
          preferences,
          settings,
          userPreferencesLoaded: true,
          failedLoadingUserPreferences: false
        }
      }));
    }, () => {
      dispatch(updatePreferenceSettings({
        preferenceSettings: {
          userPreferencesLoaded: false,
          failedLoadingUserPreferences: true,
          preferences:[],
          settings: []
        }
      }));
    });
  };
};
